import { Component, Input, Output, EventEmitter, OnInit, inject, LOCALE_ID } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule, formatDate } from '@angular/common';
import { MatNativeDateModule } from '@angular/material/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'educare-date-range-picker',
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatInputModule,
    MatNativeDateModule,
    MatIconModule,
    CommonModule,
    TranslateModule
  ],
  templateUrl: './date-range-picker.component.html',
  styleUrls: ['./date-range-picker.component.scss']
})
export class DateRangePickerComponent implements OnInit {
  private readonly locale = inject(LOCALE_ID);

  @Input() formGroup!: FormGroup;
  @Input() placeholder!: string;
  @Input() maxDate: Date | null = new Date();
  @Input() minDate: Date | null = null;
  @Output() dateChange = new EventEmitter<{ start: string; end: string }>();

  ngOnInit(): void {
    this.formGroup.get('start')?.valueChanges.subscribe((startDate) => {
      const currentEnd = this.formGroup.get('end')?.value;
      if (startDate && currentEnd && this.formGroup.dirty) {
        this.formGroup.patchValue({ end: null }, { emitEvent: false });
      }
    });

    this.formGroup.valueChanges.subscribe((val) => {
      if (val.start && val.end) {
        this.dateChange.emit({
          start: formatDate(val.start, 'yyyy-MM-dd', this.locale) || '',
          end: formatDate(val.end, 'yyyy-MM-dd', this.locale) || ''
        });
      }
    });
  }

  get isDateSelected(): boolean {
    return !!this.formGroup.value.start;
  }
  onReset() {
    this.formGroup.patchValue({ start: null, end: null });
    // Emit empty date range to notify parent component that dates have been reset
    this.dateChange.emit({ start: '', end: '' });
  }
}
